<template>
  <v-col cols="12">
    <v-form ref="maxInvoiceAmountForm">
      <base-card>
        <v-card-title>
          Tope máximo para documentos electrónicos
        </v-card-title>
        <v-card-text>
          <v-row v-if="isAdmin">
            <v-col cols="12" sm="4">
              <v-select
                ref="cliente"
                v-model="data.IdCompania"
                :items="detailClients"
                item-text="text"
                item-value="IdCompania"
                label="Compañia"
                prepend-inner-icon="mdi-sitemap"
                :error="companySelectorError"
                :rules="[validateCompanyField]"
                :error-messages="helperSelectorText"
                @change="handleSelectChange"
                filter
                search-input
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-text-field
                          class="search-field"
                          v-model="search"
                          placeholder="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          hide-details
                        />
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                class="ma-2"
                style="background-color:rgb(204 33 40);color:white !important"
                @click="checkCompanyField"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="searchIfIsAdmin">
            <v-col
              cols="12"
              sm="4"
            >
              <v-switch
                v-model="data.configStatus"
                :label="`${data.configStatus ? '(Activo)' : '(Inactivo)'} Activar Alerta`"
                hide-details
                inset
              />
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                ref="maxInvoiceAmount"
                v-model="data.maxInvoiceAmount"
                label="Monto máximo permitido"
                prepend-inner-icon="mdi-currency-usd"
                type="number"
                clearable
                :rules="formRules"
                :error-messages="errorMessages"
              />
            </v-col>
            <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                class="ma-2"
                style="background-color:rgb(204 33 40);color:white !important"
                @click="validateConfigData"
              >
                Guardar
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-alert
              v-show="successAlert"
              type="success"
              text
            >
              {{ msgSuccessAlert }}
            </v-alert>

            <v-alert
              v-show="errorAlert"
              type="warning"
              text
            >
              {{ msgErrorAlert }}
            </v-alert>
          </v-row>
        </v-card-text>
      </base-card>
    </v-form>
  </v-col>
</template>

<script>

export default {
  name: 'ConfigMaxAmountInvoice',

  data() {
    return {
      data: {
        maxInvoiceAmount: '',
        configStatus: false,
      },
      searchIfIsAdmin: false,
      search: '',
      errorMessages: '',
      formHasErrors: null,
      successAlert: false,
      msgSuccessAlert: '',
      errorAlert: false,
      msgErrorAlert: '',
      formRules: [
        (v) => !!v || 'Este campo es requerido (Solo acepta números)',
        (v) => v > 0 || 'El valor del campo debe ser mayor a cero',
      ],
      companySelectorError: false,
      helperSelectorText: '',
      firstTime: true,
    }
  },

  computed: {
    statusResponseUpdateMaxInvoiceAmountConfig() {
      return this.$store.state.maxInvoiceAmount.statusSetMaxInvoiceAmountResponse
    },
    statusResponseGetMaxInvoiceAmountConfig() {
      return this.$store.state.maxInvoiceAmount.statusGetMaxInvoiceAmountResponse
    },
    detailClients() {
      if (this.isAdmin) {
        return (
          this.$store.state.maxInvoiceAmount.listClients.Mensaje || []
        )
          .filter((compania) => compania.Activo === 1)
          .filter((compania) =>
            compania.NombreCompania.toLowerCase().includes(
              this.search.toLowerCase()
            )
          )
          .map((compania) => ({
            ...compania,
            text: `[${compania.IdCompania}] ${compania.NombreCompania}`,
          }));
      }

      return (this.$store.state.maxInvoiceAmount.listClients.Mensaje || []).filter(
        (compania) =>
          compania.IdCompania ===
          JSON.parse(atob(localStorage.getItem("uid"))).idcompania
      );
    },
  },

  created () {
    this.isAdmin =
      JSON.parse(atob(localStorage.getItem("uid"))).rol === "Administrador" ||
      JSON.parse(atob(localStorage.getItem("uid"))).rol === "AdminI+D" ||
      JSON.parse(atob(localStorage.getItem("uid"))).rol === "Desarrollador"
    if(!this.isAdmin) {
      this.getMaxInvoiceAmountConfig()
      this.searchIfIsAdmin = true
    }
    this.getListClients()
  },

  watch: {
    '$store.state.maxInvoiceAmount.maxInvoiceAmountConfigData': {
        handler(data) {
          this.data.maxInvoiceAmount = data.Monto
          this.data.configStatus = data.ActivacionAlerta === '1'
      },
      deep: true
    },
    formHasErrors () {
      if (this.formHasErrors === false) {
        this.sendMaxInvoiceAmountConfig()
        this.formHasErrors = null
      }
    },
    statusResponseUpdateMaxInvoiceAmountConfig () {
      if(this.statusResponseUpdateMaxInvoiceAmountConfig === false) {
        this.generateAlertSuccess()
        this.formHasErrors = true
        this.msgSuccessAlert = this.$store.state.maxInvoiceAmount.maxInvoiceAmountConfigMessage
        this.$store.dispatch('maxInvoiceAmount/setUpdateStatusResponse', null)
      } else if(this.statusResponseUpdateMaxInvoiceAmountConfig === true) {
        this.generateAlertError()
        this.formHasErrors = true
        this.msgSuccessAlert = this.$store.state.maxInvoiceAmount.maxInvoiceAmountConfigMessage
        this.$store.dispatch('maxInvoiceAmount/setUpdateStatusResponse', null)
      }
    },
    statusResponseGetMaxInvoiceAmountConfig () {
      if(this.statusResponseGetMaxInvoiceAmountConfig === false) {
        this.searchIfIsAdmin = true
        this.generateAlertSuccess()
        this.msgSuccessAlert = this.$store.state.maxInvoiceAmount.maxInvoiceAmountConfigMessage
        this.$store.dispatch('maxInvoiceAmount/statusGetMaxInvoiceAmountResponse', null)
      } else if(this.statusResponseGetMaxInvoiceAmountConfig === true) {
        this.searchIfIsAdmin = true
        this.generateAlertError()
        this.msgSuccessAlert = this.$store.state.maxInvoiceAmount.maxInvoiceAmountConfigMessage
        this.$store.dispatch('maxInvoiceAmount/statusGetMaxInvoiceAmountResponse', null)
      }
    }
  },

  methods: {
    async getListClients () {
      await this.$store.dispatch('maxInvoiceAmount/getListClients')
    },
    async getMaxInvoiceAmountConfig () {
      await this.$store.dispatch('maxInvoiceAmount/getMaxInvoiceAmountConfigData', {
        ...this.data
      })
    },
    generateAlertSuccess () {
      this.successAlert = true
      setTimeout(() => {
        this.successAlert = false
      }, 3000)
    },
    generateAlertError () {
      this.errorAlert = true
      setTimeout(() => {
        this.errorAlert = false
      }, 3000)
    },
    validateConfigData () {
      this.formHasErrors = !this.$refs.maxInvoiceAmountForm.validate();
    },
    sendMaxInvoiceAmountConfig () {
      this.$store.dispatch('maxInvoiceAmount/updateMaxInvoiceAmountConfigData', {
        ...this.data
      })
    },
    validateCompanyField(value) {
      if ((!value || value <= 0) && this.firstTime === false) {
        this.companySelectorError = true
        this.helperSelectorText = 'El campo no puede estar vacío.'
        return false
      } else {
        this.companySelectorError = false
        this.helperSelectorText = ''
        return true
      }
    },
    checkCompanyField() {
      this.firstTime = false
      if (this.validateCompanyField(this.data.IdCompania)) {
        this.getMaxInvoiceAmountConfig()
      }
    },
    handleSelectChange (newValue) {
      this.searchIfIsAdmin = false
    }
  }
}

</script>
